<template lang='pug'>
  el-dialog.history-detail-dialog(
    :visible="visible"
    :title="$t('历史')"
    @close="$emit('close')"
    width="800px"
    :close-on-click-modal="false"
  )
    el-form(
      ref="form"
      :model="data"
      label-width="180px"
      label-position="left"
    )
      el-form-item(
        :label="$t('品牌线')"
        required
      )
        span {{ data.brand_line_name }}
      el-form-item(
        :label="$t('投放时间')"
        required
      )
        span {{ data.start_date }}
        span(style="margin: 0 10px" class="line") {{ $t('至') }}
        span {{ data.end_date }}
      el-form-item(
        :label="$t('是否有IO')"
        required
      )
        span {{ data.is_sow_io === 1 ? $t('是') : $t('否') }}
      el-form-item(
          :label="$t('子项目背景')"
          prop="remark"
        )
          span {{ data.remark != null ? data.remark : '—' }}
      el-form-item(
          :label="$t('产品卖点')"
          prop="remark"
        )
          span {{ data.selling_point != null ? data.selling_point : '—'}}
      hr.divider
      el-form-item.media-form__container(
        v-for="(media_type, i) in data.media_type"
        :key="i"
      )
        p.media-form__title {{ $t('媒体形式') }} {{ i + 1 }}
        el-form.media-form(
          :model="data.media_type[i]"
          label-width="180px"
          label-position="left"
        )
          el-form-item.form_item(
            :label="$t('媒体形式')"
            required
          )
            span {{ media_type.media_type_category_name }}
          .media-form__io__container(
            v-for="(item,index) in data.media_type[i].media_type_io"
          )
            el-form-item(
              v-for="(io,idx) in item.media_type_io_rel"
              :label="$t('IO号')"
              :key="idx"
              :rules="{ required: true, message: 'Required', trigger: 'blur' }"
              required
            )
              span {{ io.io }}
            el-form-item(
              :label="$t('IO附件')"
              required
            )
              a(
                :href="item.io_file_path"
              ) {{ item.io_file_name }}
          el-form-item.form_item(
            :label="$t('KPI')"
            prop="io"
            required
          )
            span {{ media_type.kpi_name }}
          el-form-item.form_item(
            :label="$t('是否需要投放实时优化')"
            prop="is_real_time"
            required
          )
            span {{ media_type.is_real_time === 1 ? $t('是') : $t('否') }}

          el-form-item.form_item(
            :label="$t('投放介绍')"
            prop="other_require"
          )
            span {{ media_type.other_require != null ? media_type.other_require : '—'}}
          .media-form__target__container(
            v-for="(targetForm, idx) in data.media_type[i].media_type_target_audiences"
            :key="idx"
          )
            el-form-item(
              :label="$t('目标投放人群')"
              required
            )
              span {{ targetForm.target_audiences_name }}
            el-form-item(
              :label="$t('页面/产品链接')"
              required
            )
              a(
                :href="targetForm.url"
              ) {{ targetForm.url }}
            el-form-item(
              :label="$t('预算')"
            )
              span {{ targetForm.budget / 10000 | numberWithCommas(1) }} {{ $t('万元') }}
            el-row(
              v-if="data.is_bypass || data.is_ec_reject || data.is_tp_reject"
              :gutter="20"
            )
              el-col(
                style="width: 180px"
              ) {{ $t('素材上传') }}
            el-row(
              v-if="data.is_bypass || data.is_ec_reject || data.is_tp_reject"
            )
              image-view-container(
                v-if="targetForm.media_type_target_audiences_material.length !== 0"
                :items="targetForm.media_type_target_audiences_material"
              )
              el-col(v-else) —
          template(
            v-if="data.is_bypass || data.is_ec_reject || data.is_tp_reject"
          )
            div(
              v-for="(o, idx) in data.media_type[i].media_type_qualify_info"
              style="margin-left: 66px"
            )
              el-row(
                :gutter="20"
              )
                el-col(
                  v-if="idx === 0"
                  style="width: 180px"
                ) {{ $t('资质信息') }}
                el-col(
                  :span="10"
                  :class="[idx !== 0 ? 'qualify-info-row' : '']"
                )
                  span(style="margin-right: 10px") {{ o.qualify_info_name }}
                  a(
                    :href="o.file_download_path"
                  ) {{ o.file_name }}

</template>

<script>
import axios from 'axios'
import ImageViewContainer from './ImageViewContainer'
import { numberWithCommas } from '@/umcc/util'
export default {
  components: {
    ImageViewContainer
  },
  data () {
    return {
      data: {
        media_type: [{
          media_type_category_id: 11,
          media_type_io: [
            {
              io: 'hgga'
            }
          ],
          media_type_target_audiences: [
            {
              media_type_target_audiences_material: []
            }
          ]
        }]
      }
    }
  },
  props: {
    visible: false,
    versionId: {
      type: String,
      default () {
        return null
      }
    }
  },
  mounted () {
    this.getRejectLog()
  },
  filters: {
    numberWithCommas
  },
  methods: {
    getRejectLog () {
      axios.get('/management/ec/getRejectLog', {
        params: {
          version_id: this.versionId
        }
      })
        .then(res => {
          this.data = res
        })
    }
  }
}
</script>

<style lang='stylus'>
.history-detail-dialog
  .card-title
    width 100%
    margin 0
  .divider
    width 100%
  // .el-form
  .el-form-item__content
    margin-left 0!important
    font-size 14px
  .form_item
    margin-left 66px
  .media-form__io__container
    width 606px
  .media-form__target__container
    padding 24px
    border 1px dashed #d8d8d8
    width 656px
    box-sizing border-box
    margin 0 38px 24px
  .qualify-info-row
    margin-left 180px
</style>
